export type PostAudience = 'SYNDICATE_USERS' | 'CLOSINGS' | 'INVITEES';

export const POST_AUDIENCE_OPTIONS: { label: string; value: PostAudience }[] = [
  { label: 'All LPs of my Syndicate', value: 'SYNDICATE_USERS' },
  { label: 'Only the investors in this deal', value: 'CLOSINGS' },
  { label: 'Investors invited to this deal (need not have invested)', value: 'INVITEES' },
];

export const DEFAULT_POST_AUDIENCE: PostAudience[] = ['SYNDICATE_USERS'];

type StoredAudience = {
  targetSyndicateUsers?: boolean | null;
  targetInvitees?: boolean | null;
  targetClosingStatuses?: readonly string[] | null;
};

// Posts saved before audiences were combinable have no flags; an empty audience meant "all LPs".
export function audienceFromPost(post: StoredAudience): PostAudience[] {
  const audience: PostAudience[] = [];
  if (post.targetSyndicateUsers) audience.push('SYNDICATE_USERS');
  if (post.targetClosingStatuses && post.targetClosingStatuses.length > 0)
    audience.push('CLOSINGS');
  if (post.targetInvitees) audience.push('INVITEES');
  return audience.length > 0 ? audience : DEFAULT_POST_AUDIENCE;
}

export function audienceToVariables<StageStatus>(
  audience: PostAudience[],
  targetClosingStatuses: StageStatus[] | undefined
) {
  return {
    targetSyndicateUsers: audience.includes('SYNDICATE_USERS'),
    targetInvitees: audience.includes('INVITEES'),
    targetClosingStatuses: audience.includes('CLOSINGS') ? targetClosingStatuses : undefined,
  };
}

export function isAudienceMissing(audience: PostAudience[] | undefined): boolean {
  return !audience || audience.length === 0;
}

export function isStageSelectionMissing(
  audience: PostAudience[],
  targetClosingStatuses: string[] | undefined
): boolean {
  return (
    audience.includes('CLOSINGS') && (!targetClosingStatuses || targetClosingStatuses.length === 0)
  );
}

export function describeAudience(post: StoredAudience, companyName: string): string {
  const audience = audienceFromPost(post);
  const parts = audience.map(group => {
    if (group === 'SYNDICATE_USERS') return 'all your syndicate Members';
    if (group === 'INVITEES') return `investors invited to ${companyName}`;
    const stages = (post.targetClosingStatuses || [])
      .map(status => status.toLowerCase())
      .join(', ');
    return `investors of ${companyName} whose investments are in ${stages} status`;
  });
  return parts.join(', ');
}
